import { useState, useEffect, useRef } from "react";
import { ESTILO_BOTON_MODAL_ACEPTAR } from "../../utils/const/estilos-const";
import "../../style/style-cargando.css";
import cargandoCard from "../../components/cargando-card";
import sinAccesoCard from "../../components/sin-acceso-card";

// import { SELECT_HABILITADO_DESHABILITADO } from "../../utils/const/const-select-habilitado-deshabilitado";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import Calendar from "../../components/calendar";
import moment from "moment";
import { obtenerTodasLasUnidades } from "../../api/gestion-dts/gestion";
import { obtenerListaSeguimiento } from "../../api/api-seguimiento";
import { ChevronDown, SlidersHorizontal, X, Download } from "lucide-react";
import ReporteEntregasGoogleMap from "../../components/reporte-entregas-google-map";
import { obtenerHistorico } from "../../api/api-seguimiento";
import { obtenerReporteInfoKilometraje } from "../../api/gestion-dts/api-reportes";
import { sharedExportarPdf, sharedObtenerIdEmpresa } from "../../utils/shared-functions";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../usuarios/gestionar-rol-usuario-web/pages-const";

let $ = window.$;

/** @param {unknown} val */
function escapeCsvField(val) {
  const s = val == null ? "" : String(val);
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/**
 * Flatten programa rows for CSV.
 * One CSV line per pedido-product (or pedido-only if no products).
 */
function buildEstadoEntregasCsvStrings(datosInforme, fechaEntregaLabel) {
  const header = [
    "fecha_informe",
    "vehiculo",
    "numero_documento",
    "id_cliente",
    "codigo_cliente",
    "nombre_cliente",
    "latitud",
    "longitud",
    "nombre_geocerca",
    "id_empresa",
    "fecha_proceso_workflow",
    "id_producto",
    "nombre_producto",
    "unidad_medida",
    "cantidad",
    "peso",
    "volumen",
    "monto",
    "moneda",
  ].join(",");

  const lines = [header];

  const pushRow = (
    fecha,
    placa,
    ped,
    prod
  ) => {
    const wf = Array.isArray(ped.workFlow) && ped.workFlow.length > 0
      ? ped.workFlow[ped.workFlow.length - 1]
      : null;
    const fechaWF = wf?.fechaProceso
      ? moment(wf.fechaProceso).format("YYYY-MM-DD HH:mm:ss")
      : "";

    lines.push([
      escapeCsvField(fecha),
      escapeCsvField(placa),
      escapeCsvField(ped.numeroDocumento),
      escapeCsvField(ped.idCliente),
      escapeCsvField(ped.codigoCliente),
      escapeCsvField(ped.nombreCliente),
      escapeCsvField(ped.latitud),
      escapeCsvField(ped.longitud),
      escapeCsvField(ped.nombreGeocerca),
      escapeCsvField(ped.idEmpresa),
      escapeCsvField(fechaWF),
      escapeCsvField(prod?.idProducto ?? ""),
      escapeCsvField(prod?.nombreProducto ?? ""),
      escapeCsvField(prod?.unidadMedida ?? ""),
      escapeCsvField(prod?.cantidad ?? ""),
      escapeCsvField(prod?.peso ?? ""),
      escapeCsvField(prod?.volumen ?? ""),
      escapeCsvField(prod?.monto ?? ""),
      escapeCsvField(prod?.moneda ?? ""),
    ].join(","));
  };

  for (const grupo of datosInforme || []) {
    const placa = grupo.labelPlaca ?? "";
    const lista = Array.isArray(grupo.detallePedidoProgramado)
      ? grupo.detallePedidoProgramado
      : [];
    for (const ped of lista) {
      const prods = Array.isArray(ped.productos) ? ped.productos : [];
      if (prods.length === 0) {
        pushRow(fechaEntregaLabel, placa, ped, null);
      } else {
        for (const prod of prods) {
          pushRow(fechaEntregaLabel, placa, ped, prod);
        }
      }
    }
  }

  const bom = "\uFEFF";
  return bom + lines.join("\r\n");
}

export default function ReporteEstadoEntregasPage() {
  const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
  // const history = useHistory();
  const { t } = useTranslation();
  // const [rowsData, setRowsData] = useState([]);
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
  // const [showModalFormGenerico, setShowModalFormGenerico] = useState(false);
  // const [formData, setFormData] = useState({});
  // const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

  const [fechaSelected, setFechaSelected] = useState(moment().format("YYYY-MM-DD"));
  const [listaVehiculos, setListaVehiculos] = useState([]);
  const [vehiculoSelected, setVehiculoSelected] = useState(null);

  const [numeroDocumento, setNumeroDocumento] = useState("");

  const [datosInforme, setDatosInforme] = useState(null);
  const [expandedMapKeys, setExpandedMapKeys] = useState(() => new Set());
  const [plannedKmBySection, setPlannedKmBySection] = useState({});
  const [apiKmBySection, setApiKmBySection] = useState({});
  const [apiKmRangeBySection, setApiKmRangeBySection] = useState({});
  const [apiKmLoadingBySection, setApiKmLoadingBySection] = useState({});
  const [apiKmFiltersVisibleBySection, setApiKmFiltersVisibleBySection] = useState({});
  const [exportPdfRunning, setExportPdfRunning] = useState(false);
  const [exportPdfPercent, setExportPdfPercent] = useState(0);

  const contentRef = useRef(null);

  const [btnBuscar, setBtnBuscar] = useState(false);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    let tieneAcceso = false;
    try {
      let objEnviar = {};
      if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
        tieneAcceso = true;
        setBtnBuscar(true);
      }
      if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
        const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
        objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
        const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
        if (response.error === false && response.data !== undefined) {
          const permisos = JSON.parse(response.data.permisos);
          // console.log('permisos');
          // console.log(permisos);
          if (Array.isArray(permisos) && permisos.length > 0) {
            const manage = permisos.find(p => p.id === 10);
            if (manage !== undefined && manage !== null) {
              const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.REPORTE_ESTADO_ENTREGAS);
              // console.log('permisosPage');
              // console.log(permisosPage);
              tieneAcceso = permisosPage.checked;
              if (tieneAcceso === false) {
                return;
              }
              const permisoBtnBuscar = permisosPage.acciones.find(a => a.value === 'btn_buscar');
              setBtnBuscar(permisoBtnBuscar?.checked);
            }
          }
        }
      }
      if (tieneAcceso === true) {

        const listaUnidades = await obtenerTodasLasUnidades();
        // console.log('listaUnidades');
        // console.log(listaUnidades);
        setListaVehiculos(listaUnidades);
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
      setTieneAccesoAlModulo(tieneAcceso);
    }
  };

  const obtenerDatosInforme = async () => {
    try {
      if (moment(fechaSelected).isValid() === false) {
        showToast(t("alert_fecha_invalida"), "error");
        return;
      }
      // if (vehiculoSelected === null) {
      //   showToast(t("alert_debe_seleccionar_vehiculo"), "error");
      //   return;
      // }
      // console.log('fechaSelected', fechaSelected);
      // console.log('listaVehiculos', vehiculoSelected);
      // console.log('numeroDocumento', numeroDocumento);
      let objEnviar = {};
      objEnviar.fechaEntrega = fechaSelected;
      objEnviar.listaVehiculos = vehiculoSelected;
      objEnviar.numeroDocumentoFiltro = numeroDocumento;
      // console.log('objEnviar');
      // console.log(objEnviar);
      // return;
      setProcessingVisible(true);
      const datosSeguimiento = await obtenerListaSeguimiento(objEnviar);
      console.log('datosSeguimiento');
      console.log(datosSeguimiento);
      setDatosInforme(datosSeguimiento);
      setProcessingVisible(false);
    } catch (err) {
      console.log('obtenerDatosInforme err');
      console.log(err);
      showToast(t("alert_error_al_obtener_datos_informe"), "error");
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleExportarPdf = async () => {
    try {
      await sharedExportarPdf(contentRef, "reporte-estado-entregas", {
        onStart: () => {
          setExportPdfRunning(true);
          setExportPdfPercent(0);
        },
        onProgress: ({ percent }) => {
          setExportPdfPercent(Number(percent) || 0);
        },
        onFinish: () => {
          setExportPdfRunning(false);
          setExportPdfPercent(0);
        },
        onError: () => {
          showToast(t("label_sin_datos"), "error");
        },
      });
    } catch (err) {
      setExportPdfRunning(false);
      setExportPdfPercent(0);
      showToast(t("label_sin_datos"), "error");
    }
  };

  const handleExportarCsv = () => {
    try {
      if (!Array.isArray(datosInforme) || datosInforme.length === 0) {
        showToast(t("label_sin_datos"), "warning");
        return;
      }
      const csv = buildEstadoEntregasCsvStrings(datosInforme, fechaSelected);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `reporte-estado-entregas-${fechaSelected}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.log(e);
      showToast(t("alert_error_al_obtener_datos_informe"), "error");
    }
  };

  const renderWorkflowContent = (workflow) => {
    // const estadoEtiqueta = (step) => {
    //   if (!step || step.idEstadoPendiente == null) return "—";
    //   if (typeof step.idEstadoPendiente === "string") {
    //     return t(step.idEstadoPendiente);
    //   }
    //   if (step.estadoPendiente != null && String(step.estadoPendiente).length > 0) {
    //     return String(step.estadoPendiente);
    //   }
    //   return String(step.idEstadoPendiente);
    // };

    const fechaEtiqueta = (step) =>
      step?.fechaProceso
        ? moment(step.fechaProceso).format("YYYY-MM-DD HH:mm:ss")
        : "";

    try {
      if (!Array.isArray(workflow) || workflow.length === 0) {
        return (
          <>
            <div className="mb-2 text-[11px] font-semibold text-gray-600 sm:text-xs">{t("label_workflow")}</div>
            <span className="text-xs text-gray-500">—</span>
          </>
        );
      }

      return (
        <>
          <div className="mb-2 text-[11px] font-semibold text-gray-600 sm:text-xs">{t("label_workflow")}</div>
          <ul className="m-0 list-none space-y-1.5 p-0">
            {workflow.map((step, index) => {
              const fecha = fechaEtiqueta(step);
              const keySuffix =
                step?.fechaProceso != null
                  ? String(step.fechaProceso)
                  : `${index}-${String(step?.idEstadoPendiente ?? "")}`;
              let estado = null;
              let etiqueta = "";
              // console.log('step');
              // console.log(step);
              if (index === 0) {
                estado = step;
                // console.log('estadoIniciado');
                // console.log(estadoIniciado);
                etiqueta = t(estado.idEstadoPendiente);
                // console.log('etiqueta');
                // console.log(etiqueta);
              }
              if (index === 1) {
                estado = step;
                // console.log('estadoIniciado');
                // console.log(estadoIniciado);
                etiqueta = t(estado.idEstadoIniciado);
                // console.log('etiqueta');
                // console.log(etiqueta);
              }
              if (index > 1) {
                // console.log('index > 1');
                // console.log(step);
                estado = step;
                etiqueta = t(estado.estado);
              }
              return (
                <li key={"wf-" + index + "-" + keySuffix} className="flex flex-wrap items-baseline gap-x-2 gap-y-1 text-[11px] sm:text-xs">
                  <span className="font-medium text-gray-900">{etiqueta}</span>
                  {fecha ? (
                    <span className="whitespace-nowrap tabular-nums text-gray-600">{fecha}</span>
                  ) : null}
                </li>
              );
            })}
          </ul>
        </>
      );
    } catch (err) {
      console.log("renderWorkflowContent err");
      console.log(err);
      return (
        <>
          <div className="mb-2 text-[11px] font-semibold text-gray-600 sm:text-xs">{t("label_workflow")}</div>
          <span className="text-xs text-gray-500">—</span>
        </>
      );
    }
  };

  const MapaEntregaSection = ({ item, stops }) => {
    const [historico, setHistorico] = useState(null);
    const [kilometraje, setKilometraje] = useState(null);
    const [cargandoMapa, setCargandoMapa] = useState(true);
    const [errorMapa, setErrorMapa] = useState(null);
    const [historicoFiltersVisible, setHistoricoFiltersVisible] = useState(false);

    const fechaBase = moment(item.fechaEntregaProgramada).format("YYYY-MM-DD");
    const [historicoDateIni, setHistoricoDateIni] = useState(fechaBase);
    const [historicoDateFin, setHistoricoDateFin] = useState(fechaBase);
    const [historicoHoraIni, setHistoricoHoraIni] = useState("00:00");
    const [historicoHoraFin, setHistoricoHoraFin] = useState("23:59");
    const [appliedRange, setAppliedRange] = useState({
      dateIni: fechaBase,
      dateFin: fechaBase,
      horaIni: "00:00",
      horaFin: "23:59",
    });

    useEffect(() => {
      const nuevaFechaBase = moment(item.fechaEntregaProgramada).format("YYYY-MM-DD");
      setHistoricoDateIni(nuevaFechaBase);
      setHistoricoDateFin(nuevaFechaBase);
      setHistoricoHoraIni("00:00");
      setHistoricoHoraFin("23:59");
      setAppliedRange({
        dateIni: nuevaFechaBase,
        dateFin: nuevaFechaBase,
        horaIni: "00:00",
        horaFin: "23:59",
      });
    }, [item]);

    useEffect(() => {
      let isMounted = true;

      const cargarMapaData = async () => {
        try {
          setCargandoMapa(true);
          setErrorMapa(null);

          const objHistorico = {
            fechaHoraIni: moment(appliedRange.dateIni).format("DD/MM/YYYY") + ` ${appliedRange.horaIni}:00`,
            fechaHoraFin: moment(appliedRange.dateFin).format("DD/MM/YYYY") + ` ${appliedRange.horaFin}:59`,
            placa: String(item.valuePlaca).trim(),
          };

          const objRecorrido = {
            fechaHoraInicio: moment(appliedRange.dateIni).format("YYYY-MM-DD") + ` ${appliedRange.horaIni}:00`,
            fechaHoraFin: moment(appliedRange.dateFin).format("YYYY-MM-DD") + ` ${appliedRange.horaFin}:59`,
            placa: String(item.valuePlaca).trim(),
            idEmpresa: sharedObtenerIdEmpresa(),
          };

          const [responseHistorico, responseInfoKilometraje] = await Promise.all([
            obtenerHistorico(objHistorico),
            obtenerReporteInfoKilometraje(objRecorrido),
          ]);

          if (!isMounted) return;
          setHistorico(responseHistorico);
          setKilometraje(responseInfoKilometraje);
        } catch (err) {
          if (!isMounted) return;
          setErrorMapa(err);
        } finally {
          if (isMounted) setCargandoMapa(false);
        }
      };

      cargarMapaData();
      return () => {
        isMounted = false;
      };
    }, [item, appliedRange]);

    const handleActualizarHistoricoParametros = () => {
      setAppliedRange({
        dateIni: historicoDateIni,
        dateFin: historicoDateFin,
        horaIni: historicoHoraIni,
        horaFin: historicoHoraFin,
      });
    };

    return (
      <div className="relative">
        <button
          type="button"
          onClick={() => setHistoricoFiltersVisible((v) => !v)}
          className="absolute top-16 right-3 z-10 bg-white/95 border border-gray-200 rounded-md shadow-sm p-2 hover:bg-white text-gray-700"
          title={t("label_configuracion")}
          aria-label={t("label_configuracion")}
        >
          {historicoFiltersVisible ? <X className="h-4 w-4" /> : <SlidersHorizontal className="h-4 w-4" />}
        </button>

        {historicoFiltersVisible && (
          <div className="absolute top-16 right-3 z-10 bg-white/95 border border-gray-200 rounded-md shadow-sm p-3 text-xs text-gray-700 mt-12 w-[320px]">
            <div className="grid grid-cols-[64px_1fr_90px] gap-2 items-center">
              <span className="font-medium">{t("label_inicio")}</span>
              <Calendar
                value={historicoDateIni}
                onChange={(v) => setHistoricoDateIni(v)}
                format="YYYY-MM-DD"
                placeholder="YYYY-MM-DD"
              />
              <input
                type="time"
                value={historicoHoraIni}
                onChange={(e) => setHistoricoHoraIni(e.target.value)}
                className="w-full px-2 py-2 border border-gray-300 rounded-lg text-sm"
              />
            </div>
            <div className="grid grid-cols-[64px_1fr_90px] gap-2 items-center mt-2">
              <span className="font-medium">{t("label_fin")}</span>
              <Calendar
                value={historicoDateFin}
                onChange={(v) => setHistoricoDateFin(v)}
                format="YYYY-MM-DD"
                placeholder="YYYY-MM-DD"
              />
              <input
                type="time"
                value={historicoHoraFin}
                onChange={(e) => setHistoricoHoraFin(e.target.value)}
                className="w-full px-2 py-2 border border-gray-300 rounded-lg text-sm"
              />
            </div>
            <button
              type="button"
              onClick={handleActualizarHistoricoParametros}
              className="mt-3 w-full px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium"
            >
              {t("label_actualizar")}
            </button>
          </div>
        )}

        {cargandoMapa ? (
          <div className="px-1 py-2 text-xs text-gray-500">{t("alert_procesando_solicitud")}</div>
        ) : errorMapa != null ? (
          <div className="px-1 py-2 text-xs text-red-600">{t("label_sin_datos")}</div>
        ) : (
          <ReporteEntregasGoogleMap
            stops={stops}
            historico={historico}
            kilometraje={kilometraje}
            valuePlaca={item.valuePlaca}
            labelPlaca={item.labelPlaca}
            fechaEntrega={item.fechaEntregaProgramada}
          />
        )}
      </div>
    );
  };

  const renderMapaEntrega = (item) => {
    const stops = Array.isArray(item?.detallePedidoProgramado)
      ? item.detallePedidoProgramado
      : [];
    return <MapaEntregaSection item={item} stops={stops} />;
  };

  const toggleMapaEntrega = (key) => {
    setExpandedMapKeys((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  };

  const getDefaultApiRange = (item) => {
    const baseDate = moment(item?.fechaEntregaProgramada).format("YYYY-MM-DD");
    return {
      dateIni: baseDate,
      dateFin: baseDate,
      horaIni: "00:00",
      horaFin: "23:59",
    };
  };

  const fetchApiKmForSection = async (item, sectionKey, range) => {
    try {
      setApiKmLoadingBySection((prev) => ({ ...prev, [sectionKey]: true }));
      const objRecorrido = {
        fechaHoraInicio: `${moment(range.dateIni).format("YYYY-MM-DD")} ${range.horaIni}:00`,
        fechaHoraFin: `${moment(range.dateFin).format("YYYY-MM-DD")} ${range.horaFin}:59`,
        placa: String(item.valuePlaca || "").trim(),
        idEmpresa: sharedObtenerIdEmpresa(),
      };
      const responseInfoKilometraje = await obtenerReporteInfoKilometraje(objRecorrido);
      const apiKm = Number(responseInfoKilometraje?.data?.[item.valuePlaca]?.kilometrajeTotal);
      setApiKmBySection((prev) => ({
        ...prev,
        [sectionKey]: Number.isFinite(apiKm) ? apiKm : null,
      }));
    } catch (err) {
      setApiKmBySection((prev) => ({ ...prev, [sectionKey]: null }));
    } finally {
      setApiKmLoadingBySection((prev) => ({ ...prev, [sectionKey]: false }));
    }
  };

  const toggleApiKmFilters = (sectionKey) => {
    setApiKmFiltersVisibleBySection((prev) => ({
      ...prev,
      [sectionKey]: !prev[sectionKey],
    }));
  };

  useEffect(() => {
    if (!Array.isArray(datosInforme) || datosInforme.length === 0) return;
    const nextRanges = {};
    datosInforme.forEach((item, idxVeh) => {
      const sectionKey = `${item?.labelPlaca ?? "veh"}-${idxVeh}`;
      const range = getDefaultApiRange(item);
      nextRanges[sectionKey] = range;
      fetchApiKmForSection(item, sectionKey, range);
    });
    setApiKmRangeBySection(nextRanges);
  }, [datosInforme]);

  const waitForGoogleMaps = async (timeoutMs = 8000) => {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      if (window?.google?.maps) return true;
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => setTimeout(resolve, 250));
    }
    return false;
  };

  const calcularKmRutaPlanificada = async (programa) => {
    try {
      if (!window?.google?.maps) return null;
      const maps = window.google.maps;
      const points = (programa || [])
        .map((p) => ({
          lat: parseFloat(p?.latitud),
          lng: parseFloat(p?.longitud),
        }))
        .filter(
          (p) =>
            !Number.isNaN(p.lat) &&
            !Number.isNaN(p.lng) &&
            Number.isFinite(p.lat) &&
            Number.isFinite(p.lng)
        );

      if (points.length < 2) return 0;

      const directionsService = new maps.DirectionsService();
      const MAX_STOPS_PER_SEGMENT = 25;
      let totalMeters = 0;

      const requestRoute = (origin, destination, waypoints) =>
        new Promise((resolve, reject) => {
          directionsService.route(
            {
              origin,
              destination,
              waypoints,
              travelMode: maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status !== maps.DirectionsStatus.OK) {
                reject(new Error(String(status)));
                return;
              }
              resolve(result);
            }
          );
        });

      for (let start = 0; start < points.length - 1; start += (MAX_STOPS_PER_SEGMENT - 1)) {
        const endExclusive = Math.min(start + MAX_STOPS_PER_SEGMENT, points.length);
        const segmentPoints = points.slice(start, endExclusive);
        if (segmentPoints.length < 2) continue;

        const origin = new maps.LatLng(segmentPoints[0].lat, segmentPoints[0].lng);
        const destination = new maps.LatLng(
          segmentPoints[segmentPoints.length - 1].lat,
          segmentPoints[segmentPoints.length - 1].lng
        );
        const waypoints = segmentPoints
          .slice(1, -1)
          .map((p) => ({ location: new maps.LatLng(p.lat, p.lng), stopover: true }));

        // eslint-disable-next-line no-await-in-loop
        const result = await requestRoute(origin, destination, waypoints);
        const route = result?.routes?.[0];
        if (!route) continue;
        (route.legs || []).forEach((leg) => {
          if (leg?.distance?.value) totalMeters += Number(leg.distance.value);
        });
      }

      return totalMeters / 1000;
    } catch (err) {
      return null;
    }
  };

  useEffect(() => {
    let cancelled = false;
    setPlannedKmBySection({});

    const calcularTodos = async () => {
      if (!Array.isArray(datosInforme) || datosInforme.length === 0) return;
      const ready = await waitForGoogleMaps();
      if (!ready || cancelled) return;

      for (let idxVeh = 0; idxVeh < datosInforme.length; idxVeh++) {
        if (cancelled) return;
        const item = datosInforme[idxVeh];
        const mapSectionKey = `${item?.labelPlaca ?? "veh"}-${idxVeh}`;
        const programa = Array.isArray(item?.detallePedidoProgramado) ? item.detallePedidoProgramado : [];
        // eslint-disable-next-line no-await-in-loop
        const km = await calcularKmRutaPlanificada(programa);
        if (cancelled) return;
        setPlannedKmBySection((prev) => ({ ...prev, [mapSectionKey]: km }));
      }
    };

    calcularTodos();
    return () => {
      cancelled = true;
    };
  }, [datosInforme]);

  const renderTablaPedidos = () => {
    try {
      if (!Array.isArray(datosInforme)) {
        return (
          <div className="text-sm text-gray-600 mt-4">{t("label_sin_datos")}</div>
        );
      }
      if (datosInforme.length === 0) {
        return (
          <div className="text-sm text-gray-600 mt-4">{t("label_sin_datos")}</div>
        );
      }

      return (
        <div id="reporte-estado-entregas-resultados" className="mt-6 space-y-6 print:space-y-4">
          <p className="hidden print:block text-sm text-gray-800 border-b border-gray-300 pb-2">
            <span className="font-semibold">{t("label_fecha_programada")}:</span> {fechaSelected}
          </p>

          <div className="flex flex-wrap items-center justify-end gap-2 print:hidden">
            <button
              type="button"
              onClick={handleExportarPdf}
              disabled={exportPdfRunning}
              className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50"
            >
              <Download className="h-4 w-4" aria-hidden />
              {exportPdfRunning
                ? `${t("label_exportar_pdf")} (${exportPdfPercent}%)`
                : t("label_exportar_pdf")}
            </button>
            {/* <button
              type="button"
              onClick={handleExportarCsv}
              className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700"
            >
              <Download className="h-4 w-4" aria-hidden />
              {t("label_exportar_csv")}
            </button> */}
          </div>

          {datosInforme.map((item, idxVeh) => {
            const programa = Array.isArray(item.detallePedidoProgramado) ? item.detallePedidoProgramado : [];
            const realizadosCount = Array.isArray(item.detallePedidosFinalizados)
              ? item.detallePedidosFinalizados.length
              : 0;
            const mapSectionKey = `${item.labelPlaca ?? "veh"}-${idxVeh}`;
            const isMapaVisible = expandedMapKeys.has(mapSectionKey);
            const plannedKm = plannedKmBySection[mapSectionKey];
            const apiKm = apiKmBySection[mapSectionKey];
            const apiRange = apiKmRangeBySection[mapSectionKey] || getDefaultApiRange(item);
            const apiLoading = apiKmLoadingBySection[mapSectionKey] === true;
            const showApiKmFilters = apiKmFiltersVisibleBySection[mapSectionKey] === true;

            return (
              <section
                data-pdf-block
                key={item.labelPlaca != null ? String(item.labelPlaca) + "-" + idxVeh : "veh-" + idxVeh}
                className="rounded-lg border border-gray-200 bg-white shadow-sm overflow-hidden print:shadow-none print:break-inside-avoid"
              >
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between border-b border-gray-100 px-4 py-3 bg-gray-50/80">
                  <div className="font-semibold text-gray-900 text-base">{item.labelPlaca ?? "—"}</div>
                  <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-700">
                    <span>
                      {t("label_pedidos_programados")}:{" "}
                      <span className="font-semibold tabular-nums">{programa.length}</span>
                    </span>
                    <span>
                      {t("label_pedidos_realizados")}:{" "}
                      <span className="font-semibold tabular-nums">{realizadosCount}</span>
                    </span>
                    <span>
                      {t("label_km_planificada")}:{" "}
                      <span className="font-semibold tabular-nums">
                        {plannedKm == null ? "—" : `${Number(plannedKm).toFixed(2)} km`}
                      </span>
                    </span>
                    <span>
                      {t("label_km_recorrido")}:{" "}
                      <span className="font-semibold tabular-nums">
                        {apiKm == null ? "—" : `${Number(apiKm).toFixed(2)} km`}
                      </span>
                    </span>
                    <button
                      type="button"
                      onClick={() => toggleApiKmFilters(mapSectionKey)}
                      className="inline-flex items-center justify-center p-1.5 border border-gray-300 rounded-md bg-white hover:bg-gray-50 text-gray-700"
                      title={t("label_configuracion")}
                      aria-label={t("label_configuracion")}
                    >
                      {showApiKmFilters ? <X className="h-3.5 w-3.5" /> : <SlidersHorizontal className="h-3.5 w-3.5" />}
                    </button>
                  </div>
                </div>
                {showApiKmFilters && (
                  <div className="px-4 py-2 border-b border-gray-100 bg-gray-50/60 text-xs text-gray-700">
                    <div className="grid grid-cols-1 gap-2 sm:grid-cols-[64px_1fr_90px_64px_1fr_90px_auto] sm:items-center">
                      <span className="font-medium">{t("label_inicio")}</span>
                      <Calendar
                        value={apiRange.dateIni}
                        onChange={(v) =>
                          setApiKmRangeBySection((prev) => ({
                            ...prev,
                            [mapSectionKey]: { ...apiRange, dateIni: v },
                          }))
                        }
                        format="YYYY-MM-DD"
                        placeholder="YYYY-MM-DD"
                      />
                      <input
                        type="time"
                        value={apiRange.horaIni}
                        onChange={(e) =>
                          setApiKmRangeBySection((prev) => ({
                            ...prev,
                            [mapSectionKey]: { ...apiRange, horaIni: e.target.value },
                          }))
                        }
                        className="w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs"
                      />
                      <span className="font-medium">{t("label_fin")}</span>
                      <Calendar
                        value={apiRange.dateFin}
                        onChange={(v) =>
                          setApiKmRangeBySection((prev) => ({
                            ...prev,
                            [mapSectionKey]: { ...apiRange, dateFin: v },
                          }))
                        }
                        format="YYYY-MM-DD"
                        placeholder="YYYY-MM-DD"
                      />
                      <input
                        type="time"
                        value={apiRange.horaFin}
                        onChange={(e) =>
                          setApiKmRangeBySection((prev) => ({
                            ...prev,
                            [mapSectionKey]: { ...apiRange, horaFin: e.target.value },
                          }))
                        }
                        className="w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs"
                      />
                      <button
                        type="button"
                        onClick={() => fetchApiKmForSection(item, mapSectionKey, apiRange)}
                        className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-xs font-medium"
                        disabled={apiLoading}
                      >
                        {apiLoading ? "..." : t("label_actualizar")}
                      </button>
                    </div>
                  </div>
                )}

                {programa.length === 0 ? (
                  <div className="px-4 py-3 text-sm text-gray-500">{t("label_sin_datos")}</div>
                ) : (
                  <div className="px-3 sm:px-4 pb-4 space-y-4">
                    {programa.map((ped, idxPed) => {
                      const prods = Array.isArray(ped.productos) ? ped.productos : [];
                      const rowKey =
                        `${ped.numeroDocumento ?? "doc"}-${ped.idCliente ?? idxPed}-${idxPed}`;
                      const workflow = ped.workFlow;
                      return (
                        <article
                          key={rowKey}
                          className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden print:break-inside-avoid text-xs sm:text-sm"
                        >
                          <div className="grid grid-cols-1 gap-3 px-3 py-3 sm:grid-cols-3 sm:gap-4 border-b border-gray-100 bg-gradient-to-b from-white to-gray-50/30">
                            <div className="min-w-0">
                              <div className="text-[10px] sm:text-[11px] font-semibold text-gray-500 uppercase tracking-wide">
                                {t("column_numero_documento")}
                              </div>
                              <div className="mt-0.5 font-medium text-gray-900 tabular-nums">
                                {ped.numeroDocumento ?? "—"}
                              </div>
                            </div>
                            <div className="min-w-0">
                              <div className="text-[10px] sm:text-[11px] font-semibold text-gray-500 uppercase tracking-wide">
                                {t("column_nombre_cliente")}
                              </div>
                              <div className="mt-0.5 text-gray-900 break-words">
                                {ped.nombreCliente ?? "—"}
                              </div>
                            </div>
                            <div className="min-w-0">
                              <div className="text-[10px] sm:text-[11px] font-semibold text-gray-500 uppercase tracking-wide">
                                {t("label_geocerca")}
                              </div>
                              <div className="mt-0.5 text-gray-800 break-words sm:whitespace-normal">
                                {ped.nombreGeocerca ?? "—"}
                              </div>
                            </div>
                          </div>
                          <div className="border-b border-gray-100 bg-gray-50/60 px-3 py-3">
                            <div className="mb-2 text-[11px] font-semibold text-gray-600 sm:text-xs">
                              {t("label_productos")}
                            </div>
                            {prods.length === 0 ? (
                              <span className="text-xs text-gray-500">—</span>
                            ) : (
                              <div className="overflow-x-auto rounded-md border border-gray-200 bg-white">
                                <table className="min-w-[560px] w-full text-left text-[11px] sm:text-xs">
                                  <thead>
                                    <tr className="border-b border-gray-100 bg-white text-gray-600">
                                      <th className="px-2 py-1.5 font-semibold">{t("column_nombre")}</th>
                                      <th className="whitespace-nowrap px-2 py-1.5 font-semibold">
                                        {t("column_unidad_medida")}
                                      </th>
                                      <th className="whitespace-nowrap px-2 py-1.5 text-right font-semibold">
                                        {t("column_cantidad")}
                                      </th>
                                      <th className="whitespace-nowrap px-2 py-1.5 text-right font-semibold">
                                        {t("column_weight")}
                                      </th>
                                      <th className="whitespace-nowrap px-2 py-1.5 text-right font-semibold">
                                        {t("column_volumen")}
                                      </th>
                                      <th className="whitespace-nowrap px-2 py-1.5 text-right font-semibold">
                                        {t("column_monto")}
                                      </th>
                                      <th className="whitespace-nowrap px-2 py-1.5 font-semibold">
                                        {t("column_moneda")}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {prods.map((p, ip) => (
                                      <tr
                                        key={
                                          p.idProducto != null
                                            ? String(p.idProducto) + "-" + ip
                                            : "p-" + ip
                                        }
                                        className="border-b border-gray-50 last:border-0"
                                      >
                                        <td className="max-w-[14rem] px-2 py-1.5 break-words text-gray-900">
                                          {p.nombreProducto ?? "—"}
                                        </td>
                                        <td className="whitespace-nowrap px-2 py-1.5 text-gray-700">
                                          {p.unidadMedida ?? "—"}
                                        </td>
                                        <td className="tabular-nums px-2 py-1.5 text-right text-gray-800">
                                          {p.cantidad ?? "—"}
                                        </td>
                                        <td className="tabular-nums px-2 py-1.5 text-right text-gray-800">
                                          {p.peso ?? "—"}
                                        </td>
                                        <td className="tabular-nums px-2 py-1.5 text-right text-gray-800">
                                          {p.volumen ?? "—"}
                                        </td>
                                        <td className="tabular-nums px-2 py-1.5 text-right text-gray-800">
                                          {p.monto != null
                                            ? Number(p.monto).toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })
                                            : "—"}
                                        </td>
                                        <td className="whitespace-nowrap px-2 py-1.5 text-gray-700">
                                          {p.moneda ?? "—"}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                          <div className="bg-gray-50/40 px-3 py-3">{renderWorkflowContent(workflow)}</div>
                        </article>
                      );
                    })}
                  </div>
                )}
                <div className="border-t border-gray-100 bg-white">
                  <button
                    type="button"
                    onClick={() => toggleMapaEntrega(mapSectionKey)}
                    className="w-full px-4 py-2.5 flex items-center justify-between text-sm font-medium text-gray-700 hover:bg-gray-50"
                    aria-expanded={isMapaVisible}
                  >
                    <span>{t("label_mapa")}</span>
                    <ChevronDown
                      className={`h-4 w-4 text-gray-500 transition-transform duration-200 ${isMapaVisible ? "rotate-180" : ""}`}
                      aria-hidden
                    />
                  </button>
                  {isMapaVisible ? (
                    <div className="px-4 pb-3">
                      {renderMapaEntrega(item)}
                    </div>
                  ) : null}
                </div>
              </section>
            );
          })}
        </div>
      );
    } catch (err) {
      console.log('renderTablaPedidos err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  };

  const render = () => {
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                <h2 className="text-xl font-bold text-gray-900">{t("label_reporte_estado_entregas")}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_genera_el_reporte_de_estado_de_entregas")}</p>
            </div>
            <div className="flex items-center gap-2">
              {/* <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={() => {
                  setFormData({
                    ...formData,
                    id: 0,
                    descripcion: "",
                    nota: "",
                  });
                  setShowModalFormGenerico(true);
                }}
              >
                {t("label_nuevo")}
              </button> */}
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4 print:hidden">
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              <label className="block text-sm font-medium text-gray-700 mb-0">{t("label_fecha_programada")}</label>
              <Calendar
                value={fechaSelected}
                onChange={(date) => setFechaSelected(date)}
                placeholder={t("placeholder_seleccione_fecha")}
                id="fecha_asignacion"
                name="fecha_asignacion"
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              <label className="block text-sm font-medium text-gray-700 mb-0">
                {t("label_vehiculo")}
              </label>
              <Select options={listaVehiculos}
                isSearchable={true}
                isClearable={true}
                value={vehiculoSelected}
                onChange={(event) => setVehiculoSelected(event)}
                placeholder={t("placeholder_seleccione_vehiculo")}
                isMulti={true}
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              <label className="block text-sm font-medium text-gray-700 mb-0">
                {t("label_numero_documento")}
              </label>
              <input
                type="text"
                value={numeroDocumento}
                onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9,._\- ]/g, "");
                  setNumeroDocumento(sanitizedValue)
                }}
                placeholder={t("placeholder_ingrese_numero_documento")}
                className="w-full p-1.5 border border-gray-300 rounded-md"
                maxLength={24}
              />
              <p className="text-sm text-gray-500 flex justify-end">{String(numeroDocumento).length}/24</p>
            </div>
          </div>
          {/* <br /> */}
          {btnBuscar === true && (
            <div className="grid grid-cols-12 gap-4 mt-2 print:hidden">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12 flex justify-end">
                <button
                  type="button"
                  className={ESTILO_BOTON_MODAL_ACEPTAR}
                  onClick={() => { obtenerDatosInforme(); }}
                >
                  {t("label_buscar")}
                </button>
              </div>
            </div>
          )}
          <br />
          <div className="print:hidden" ref={contentRef}>
            {renderTablaPedidos()}
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarTipoCombustible render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
